<template>
    <div :is="tag" :class="classes" :style="styles" v-text="timestampString" />
</template>

<script>
export default {
    props: {
        timestamp: String,
        classes: String,
        styles: String,
        tag: {
            type: String,
            default: 'span',
        },
        prefix: String,
    },
    data: function () {
        return {
            timeStampInterval: null,
            generatedTimestamp: null,
            currentDate: null,
        }
    },

    created() {
        this.currentDate = this.$moment().startOf('day').subtract(2, 'days')
        this.setGeneratedTimestamp()
    },

    mounted() {
        this.setTimeStampInterval()
    },

    beforeUnmount() {
        if (this.timeStampInterval) {
            clearInterval(this.timeStampInterval)
        }
    },

    watch: {
        timestamp() {
            this.setGeneratedTimestamp()
        },
    },

    computed: {
        timestampString() {
            if (this.prefix) {
                return this.prefix + ' ' + this.generatedTimestamp
            }
            return this.generatedTimestamp
        },
    },

    methods: {
        setTimeStampInterval() {
            let anHourAgo = this.$moment().subtract(45, 'minutes')
            let momentTimeStamp = this.$moment(this.timestamp)

            if (momentTimeStamp.isAfter(anHourAgo)) {
                this.timeStampInterval = setInterval(() => {
                    if (momentTimeStamp.isAfter(anHourAgo)) {
                        this.setGeneratedTimestamp()
                    }
                }, 10 * 1000)
                // Remove the updating when it is more than 45 minutes since comment was posted or updated.
                // Since moment writes 'an hour ago' after 45 minutes (Can change this using moment.relativeTimeThreshold)
                let diff = momentTimeStamp.diff(
                    this.$moment().subtract(45, 'minutes')
                )
                setTimeout(() => {
                    if (this.timeStampInterval) {
                        clearInterval(this.timeStampInterval)
                    }
                }, diff)
            }
        },

        setGeneratedTimestamp() {
            let date = this.$moment(this.timestamp)
            if (
                date.isAfter(this.currentDate) ||
                !this.useTimeStampForPastDates
            ) {
                this.generatedTimestamp = date.fromNow().replace('för ', '')
            } else if (this.useTimeStampForPastDates) {
                this.generatedTimestamp = date.format('YYYY-MM-DD')
            }
        },
    },
}
</script>
